
<div [innerHTML]="safeHtml"></div>
